import type {
  PurchasePlanInfo,
  PurchasePreviewInfo,
} from '@/modules/licenses/types.ts'
import { apiClient } from '@/utils/axios.ts'

async function postPurchase(
  creatorId: number,
  anticipatedPrice: number,
  planPriceId: string,
  quantity: number,
) {
  const params = {
    creatorId: creatorId,
    anticipatedPrice,
    quantity,
  }
  const res = await apiClient.post(
    `licenses/purchase/purchase/${planPriceId}`,
    {},
    { params },
  )

  return res.data
}

async function getPurchasePreview(
  planPriceId: string,
  quantity: number,
): Promise<PurchasePreviewInfo> {
  const res = await apiClient.get(`licenses/purchase/preview/${planPriceId}`, {
    params: { quantity },
  })

  return res.data
}

async function getPurchasePlans(): Promise<PurchasePlanInfo[]> {
  const res = await apiClient.get('licenses/purchase/plans')

  return res.data
}

export const purchaseService = {
  postPurchase,
  getPurchasePreview,
  getPurchasePlans,
}
